import axiosInstance from "../../routes/axiosConfig";

const API_BASE_URL = process.env.REACT_APP_API_URL;

const UserService = {
  createUser: async (userData) => {
    try {
      const payload = {
        login: userData.login,
        password: userData.password,
        name: userData.name,
        position: {
          optionsId: userData.position.optionsId,
          description: userData.position.description,
          type: userData.position.type,
        },
        status: {
          optionsId: userData.status.optionsId,
          description: userData.status.description,
          type: userData.status.type,
        },
        role: {
          optionsId: userData.role.optionsId,
          description: userData.role.description,
          type: userData.role.type,
        },
        company: {
          optionsId: userData.company.optionsId,
          description: userData.company.description,
          type: userData.company.type,
        },
        registerDate: userData.registerDate,

        enabled: true,
        accountNonLocked: true,
        accountNonExpired: true,
        credentialsNonExpired: true,
        username: userData.login,
      };

      const response = await axiosInstance.post(
        `${API_BASE_URL}/employees`,
        payload
      );
      return response.data;
    } catch (error) {
      console.error(
        "Erro ao criar usuário:",
        error.response?.data || error.message
      );
      throw error;
    }
  },
};

export default UserService;
